import React from 'react'

import styled from 'styled-components'

const Toggle = ({ toggle, setToggle, heading = '' }) => {
  return (
    <Wrapper>
      <StyledToggle
        onClick={() => setToggle(!toggle)}
        className={toggle ? 'active' : ''}
      >
        <div className="tog" />
      </StyledToggle>
      {heading && <p className="toggle__title">{heading}</p>}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;

  .toggle__title {
    color: rgb(14, 19, 36);
    letter-spacing: 0.03em;
    line-height: 1.5rem;
    font-weight: 300;
    margin: 0;
  }
`

const StyledToggle = styled.div`
  height: 19px;
  width: 38px;
  background: #aeb3c9;
  border-radius: 100px;
  position: relative;
  cursor: pointer;
  transition: all 0.3s ease;

  .tog {
    position: absolute;
    top: 50%;
    left: 2px;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    transform: translateY(-50%);
    background-color: #fff;
    transition: all 0.3s ease;
  }

  &.active {
    background-color: #ff7b9b;

    .tog {
      left: calc(100% - 17px);
    }
  }
`

export default Toggle
